export const CLASSROOM = 'classroom';
export const DISTRICT = 'district';
export const GRADE_LEVEL = 'gradeLevel';
export const MONTH = 'month';
export const SCHOOL = 'school';
export const SIX_WEEKS = 'six_weeks';
export const STUDENT = 'student';
export const TODAY = 'today';
export const USER = 'user';
export const WEEK = 'week';

export const DEFAULT_CLASSROOM_PRODUCT_ID = 1;
export const DEFAULT_CLASSROOM_SHOULD_FILTER_IMPORTS_BY_GRADE_LEVEL = 0;



// WEBPACK FOOTER //
// ./frontend/a2i/js/lib/constants.js